export const removeUnitFromValue =
	<T extends string>(unit: T) =>
	(valueWithUnit: `${number}${T}`) => {
		const valueWithoutUnitStr = valueWithUnit.replace(unit, '')
		return Number(valueWithoutUnitStr)
	}

export const pxStringToNumber = (pxString: `${number}px`) =>
	removeUnitFromValue('px')(pxString)
